import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { formatBytes } from "common/utils/formats"
import "./styles.scss"

const ArchivosAdjuntosFileItem = ({
  name,
  size,
  onDelete,
  onDownload,
}: $TSMigrationFixMe) => {
  const sizeToShow = formatBytes(size)

  return (
    <div className='fichero__item align-items-center'>
      <div className='fichero__item__image'>
        <FontAwesomeIcon
          icon={["fal", "file"]}
          className='icon-md adjunto-icon'
        />
      </div>

      <div className='fichero__item__content'>
        <div>
          <span className='fichero__item__titulo'>{name}</span>
        </div>

        {size && (
          <div>
            <span className='fichero__item__size'>{sizeToShow}</span>
          </div>
        )}
      </div>

      {onDownload && (
        <div
          className='fichero__item__action'
          onClick={onDownload}
        >
          <FontAwesomeIcon
            icon={["fal", "arrow-down-to-bracket"]}
            className='icon-primary'
            fontSize='20px'
          />
        </div>
      )}

      {onDelete && (
        <div
          className='fichero__item__action'
          onClick={onDelete}
        >
          <div className='bubble__trash'>
            <FontAwesomeIcon
              icon={["fal", "trash-alt"]}
              className='icon-danger'
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ArchivosAdjuntosFileItem
